module.exports = __webpack_public_path__ + "img/28.1027fe49.png";